'use strict';

var _ = require('lodash');
var SearchCriteriaRuleFactory = function SearchCriteriaRuleFactory(criteriaRuleService, configurationService, criteriaRuleDataService, momentService, optWeekService, userSecureService, userPreferencesService, flightModeService) {
  function SearchCriteriaRule(params) {
    this.level = params.level || 'Default';
    this.category = params.category || '';
    this.shortCriterionName = params.shortCriterionName || '';
    this.criterion = params.criterion || '';
    this.operator = params.operator || '';
    this.field = params.field || '';
    this.metaCategory = params.metaCategory || this.field;
    this.searchContext = params.searchContext || '';
    this.isReadOnly = params.isReadOnly || false;
    this.isHidden = params.isHidden || false;
    this.valueType = criteriaRuleService.getValueType(this.searchContext, this.level, this.category, this.criterion, this.operator);
    this.limits = this.setLimits(this.limits);
    this.leftOperand = constructField(this.valueType, params.leftOperand);
    this.leftOperand2 = constructField(this.valueType, params.leftOperand2);
    this.rightOperand = constructField(this.valueType, params.rightOperand);
  }
  function constructLimits(limits, valueType) {
    var leftOperandLimit = _.get(limits, 'leftOperand');
    var rightOperandLimit = _.get(limits, 'rightOperand');
    _.each([leftOperandLimit, rightOperandLimit], function (limitOperand) {
      if (limitOperand) {
        if (limitOperand.minDate) {
          limitOperand.minDate = constructField(valueType, limitOperand.minDate);
        }
        if (limitOperand.maxDate) {
          limitOperand.maxDate = constructField(valueType, limitOperand.maxDate);
        }
      }
    });
    return limits;
  }
  function isPositiveInteger(str) {
    return /^(0|[1-9]\d*)$/.test(str);
  }
  function isInteger(str) {
    return /^(0|(\-|)[1-9]\d*)$/.test(str);
  }
  function isValidPercentage(str) {
    var number = +str;
    return 0 <= number && number <= 1;
  }
  function isComboValueSet(value) {
    return !_.isNil(value) && value !== '';
  }
  function isMoment(date) {
    return momentService.isMoment(date);
  }
  function isValidDow(dow, operator) {
    return dow && dow.length > 0 && !(dow.length === 7 && operator === 'Is Not');
  }
  function isNotEmptyArray(attr) {
    return Array.isArray(attr) && attr.length > 0;
  }
  function isSearchRuleDateType(type) {
    return !_.isUndefined(momentService.ruleTypeToConfig(type));
  }
  function constructField(type, param) {
    if (isSearchRuleDateType(type)) {
      var now = momentService.systemNow(momentService.ruleTypeToConfig(type)).startOf('day');
      switch (param) {
        case '{{now}}':
          return now;
        case '{{yearAgo}}':
          return now.subtract(1, 'years');
        case '{{nextQuarter}}':
          return now.add(4, 'months');
        case '{{next90Days}}':
          return now.add(90, 'days');
        case '{{next20Days}}':
          return now.add(20, 'days');
        case '{{next45Days}}':
          return now.add(45, 'days');
        case '{{last30Days}}':
          return now.subtract(30, 'days');
        case '{{last45Days}}':
          return now.subtract(45, 'days');
        case '{{last90Days}}':
          return now.subtract(90, 'days');
        case '{{lastDay}}':
          return now.subtract(1, 'days');
        case '{{last15Days}}':
          return now.subtract(14, 'days');
        case '{{usersettingDays}}':
          return now.add(userPreferencesService.getUserSettingComponent('defaultSearchDays') || 90, 'days');
      }
      var res = isMoment(param) ? param : momentService.of(param, momentService.ruleTypeToConfig(type));
      return !_.isUndefined(res) && res.isValid() ? res : null;
    }
    if (type === 'multi') {
      switch (param) {
        case '{{assignedMarkets}}':
          return userSecureService.getMarketsPreferences() || configurationService.getMarketsOrLegsFromHub(false) || configurationService.getAssignedMarkets();
        case '{{assignedLegs}}':
          return userSecureService.getLegsPreferences() || flightModeService.isDAOnlyMode() && userSecureService.getMarketsPreferences() || configurationService.getMarketsOrLegsFromHub(true) || configurationService.getAssignedMarkets();
        case '{{allMarkets}}':
          return _.map(criteriaRuleDataService.getOperandData('Market', '=', 'multi'), 'value');
        case '{{allFlights}}':
          return _.map(criteriaRuleDataService.getOperandData('Flight Number', '=', 'multi'), 'value');
        case '{{romSummaryOptWeeks}}':
          return optWeekService.getFlattenedOptWeekData('ROM summary');
        case '{{romAnalysisOptWeeks}}':
          return optWeekService.getFlattenedOptWeekData('ROM analysis');
        case '{{assignedFareClasses}}':
          return _.map(criteriaRuleDataService.getOperandData('Fare Class', '=', 'multi'), 'value');
        case '{{allCabins}}':
          return configurationService.getDisplayableCabins();
        case '{{allPOSes}}':
          return _.map(criteriaRuleDataService.getOperandData('POS', '=', 'multi'), 'value');
        case '{{allDaPOSes}}':
          return _.chain(configurationService.getDaPoses()).transform(function (result, current) {
            result.push(current.spos);
          }).uniq().sortBy().value();
        case '{{allFileEvents}}':
          return configurationService.getInterfaceStatusFileEvents();
      }
    }
    if (param === '{{userId}}') {
      return configurationService.getUserId();
    }
    if (param === '{{allUsers}}') {
      return _.map(configurationService.getAllUsers(), 'userId');
    }
    return _.isBoolean(param) || _.isNumber(param) ? param : param || '';
  }
  function formatOperand(operand) {
    if (momentService.isMoment(operand)) {
      return operand.valueOf();
    }
    if (isDropdownObjectOperand(operand)) {
      return toStringDropdownObjectOperand(operand);
    }
    return operand;
  }
  function isDropdownObjectOperand(operand) {
    return _.isObject(operand) && operand.hasOwnProperty('value') && operand.hasOwnProperty('dropdownVisibleValue');
  }
  function toStringDropdownObjectOperand(operand) {
    return operand.value + '-' + operand.dropdownVisibleValue;
  }
  function getAttributes(rule) {
    return {
      level: rule.level,
      category: rule.category,
      metaCategory: rule.metaCategory,
      shortCriterionName: rule.shortCriterionName,
      criterion: rule.criterion,
      operator: rule.operator,
      field: rule.field,
      searchContext: rule.searchContext,
      leftOperand: rule.leftOperand,
      leftOperand2: rule.leftOperand2,
      rightOperand: rule.rightOperand,
      isReadOnly: rule.isReadOnly
    };
  }
  function getHashCodeAttributes(rule) {
    var attributes = getAttributes(rule);
    attributes.leftOperand = formatOperand(attributes.leftOperand);
    attributes.leftOperand2 = formatOperand(attributes.leftOperand2);
    attributes.rightOperand = formatOperand(attributes.rightOperand);
    return attributes;
  }
  SearchCriteriaRule.prototype.checkIntValue = function (operand) {
    var operandLimits = criteriaRuleService.getOperandLimits(this.searchContext, this.level, this.category, this.criterion);
    if (operandLimits) {
      return isInteger(operand) && operandLimits.min <= +operand && +operand <= operandLimits.max;
    } else {
      return isPositiveInteger(operand);
    }
  };
  SearchCriteriaRule.prototype.isValid = function () {
    var valueType = criteriaRuleService.getValueType(this.searchContext, this.level, this.category, this.criterion, this.operator);
    switch (valueType) {
      case 'text':
        return this.leftOperand !== null && this.leftOperand !== '';
      case 'int':
        return this.checkIntValue(this.leftOperand);
      case 'percent':
        return isValidPercentage(this.leftOperand);
      case 'datetime':
        return isMoment(this.leftOperand);
      case '2datetime':
        return isMoment(this.leftOperand) && isMoment(this.rightOperand);
      case 'date':
        return isMoment(this.leftOperand);
      case 'utcdate':
        return isMoment(this.leftOperand);
      case '2date':
        return isMoment(this.leftOperand) && isMoment(this.rightOperand);
      case 'utc2date':
        return isMoment(this.leftOperand) && isMoment(this.rightOperand);
      case 'time':
        return isMoment(this.leftOperand);
      case '2time':
        return isMoment(this.leftOperand) && isMoment(this.rightOperand);
      case 'dow':
        return isValidDow(this.leftOperand, this.operator);
      case 'multi':
        return isNotEmptyArray(this.leftOperand);
      case '2int':
        return this.checkIntValue(this.leftOperand) && this.checkIntValue(this.rightOperand);
      case '2percent':
        return isValidPercentage(this.leftOperand) && isValidPercentage(this.rightOperand);
      case 'combo':
        return isComboValueSet(this.leftOperand);
      case '2combo':
        return isComboValueSet(this.leftOperand) && isComboValueSet(this.rightOperand);
      default:
        return false;
    }
  };
  function compareOperand(o1, o2) {
    if (isMoment(o1) && isMoment(o2)) {
      return o1.isSame(o2);
    }
    return _.isEqual(o1, o2);
  }
  SearchCriteriaRule.prototype.isEqual = function (obj) {
    return _.isEqual(this.level, obj.level) && _.isEqual(this.category, obj.category) && _.isEqual(this.criterion, obj.criterion) && _.isEqual(this.operator, obj.operator) && compareOperand(this.leftOperand, obj.leftOperand) && compareOperand(this.leftOperand2, obj.leftOperand2) && compareOperand(this.rightOperand, obj.rightOperand) && _.isEqual(this.field, obj.field) && _.isEqual(this.searchContext, obj.searchContext);
  };
  SearchCriteriaRule.prototype.hashCode = function () {
    return _.chain(getHashCodeAttributes(this)).values().join('-').value();
  };
  SearchCriteriaRule.prototype.clone = function () {
    return new SearchCriteriaRule(getAttributes(this));
  };
  SearchCriteriaRule.prototype.setLimits = function (limits) {
    this.limits = constructLimits(limits, this.valueType);
  };
  return SearchCriteriaRule;
};
SearchCriteriaRuleFactory.$inject = ['CriteriaRuleService', 'ConfigurationService', 'CriteriaRuleDataService', 'MomentService', 'OptWeekService', 'UserSecureService', 'UserPreferencesService', 'FlightModeService'];
module.exports = SearchCriteriaRuleFactory;